import type { StatsigClient } from "@statsig/react-bindings";

/**
 * The live Statsig client, for code that lives outside React.
 *
 * The analytics service fans events out through plain provider objects, not hooks, so the Statsig
 * provider cannot reach the client through context. `ExperimentsProvider` registers whichever
 * client it created here; `logStatsigEvent` stays a no-op until then — and forever, when Statsig
 * is not configured — so callers never have to care.
 *
 * Browser-only on purpose: on the server this module would be shared between requests, and events
 * are only ever produced by visitor interactions anyway.
 */
let registeredClient: StatsigClient | null = null;

export const registerStatsigAnalyticsClient = (client: StatsigClient) => {
  if (typeof window === "undefined") {
    return;
  }

  registeredClient = client;
};

/**
 * Log one event to Statsig, the shape Pulse computes experiment metrics from.
 *
 * Values in `metadata` are strings because that is all `logEvent` accepts — stringify at the call
 * site rather than passing numbers through.
 */
export const logStatsigEvent = (
  eventName: string,
  value?: string | number,
  metadata?: Record<string, string>
) => {
  registeredClient?.logEvent(eventName, value, metadata);
};
